import { render, staticRenderFns } from "./SlV2Status.vue?vue&type=template&id=70327b28&"
import script from "./SlV2Status.vue?vue&type=script&lang=js&"
export * from "./SlV2Status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports